import { render, staticRenderFns } from "./ConfirmationSummaryInvoices.vue?vue&type=template&id=436f92e8&"
import script from "./ConfirmationSummaryInvoices.vue?vue&type=script&lang=js&"
export * from "./ConfirmationSummaryInvoices.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports